import { render, staticRenderFns } from "./CreateFrameAuction.vue?vue&type=template&id=26d60a65"
import script from "./CreateFrameAuction.vue?vue&type=script&lang=js"
export * from "./CreateFrameAuction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports